export default {
  listMailTemplate: state => state.listMailTemplate,
}